const translations = {
  en: {
    // Phone Entry
    docUpload: "Document Upload",
    enterPhone: "Enter your phone number to access your documents",
    phoneNumber: "Phone Number",
    phonePlaceholder: "(555) 123-4567",
    phoneError: "Please enter a valid 10-digit phone number",
    sendCode: "Send Verification Code",
    verifying: "Verifying...",
    multipleDeals: "Multiple deals found. Please select yours:",
    needHelp: "Need help? Contact your dealership.",

    // PIN Verification
    verifyPhone: "Verify Your Phone",
    enterCode: "Enter the 4-digit code sent to",
    codeSent: "Verification code sent",
    changePhone: "Change phone",
    resendCode: "Resend code",
    resendIn: "Resend in",
    testPin: "Test PIN (SMS not configured):",
    verificationFailed: "Verification failed",

    // Document Dashboard
    docUploadTitle: "Document Upload",
    lender: "Lender",
    docsVerified: "documents verified",
    of: "of",
    pendingReview: "pending review",
    custom: "Custom",
    uploadBtn: "Upload",
    uploading: "Uploading...",
    waitingReview: "Waiting for dealership review",
    docAccepted: "Document accepted",
    uploadedSuccess: "uploaded successfully!",
    fileTypeError: "File type not allowed. Use JPG, PNG, PDF, or HEIC.",
    fileSizeError: "File too large. Maximum size is 20MB.",
    loadError: "Failed to load documents",
    sessionExpires: "Session expires in",
    contactDealer: "Need help? Contact your dealership.",
    reason: "Reason",

    // Status labels
    verified: "Verified",
    pendingReviewStatus: "Pending Review",
    rejected: "Rejected",
    missing: "Missing",

    // Tooltips
    tooltips: {
      "Driver's License": "A clear photo of the front of your valid driver's license. Make sure all text is readable and the photo is not blurry.",
      "Proof of Income": "Recent pay stubs (last 30 days), bank statements, or tax returns showing your income. Self-employed? Provide 2 months of bank statements.",
      "Proof of Residence": "A utility bill, bank statement, or government mail from the last 60 days showing your current address.",
      "Insurance Card": "Your current auto insurance card or declaration page showing coverage for the vehicle being financed.",
      "Vehicle Registration": "The current registration document for any trade-in vehicle, or the registration for the vehicle being purchased if applicable.",
      "Bank Statements": "Last 2-3 months of bank statements showing your name, account activity, and current balance.",
      "Pay Stubs": "Your most recent pay stubs (last 2-4 weeks) showing your employer name, pay rate, and year-to-date earnings.",
      "Trade-in Title": "The original title for your trade-in vehicle. If there's a lien, we'll need the lien holder information.",
      "References": "Contact information for 3-5 personal or professional references (name, phone, relationship).",
      "Credit Application": "Your completed and signed credit application form. We may have already collected this during your visit.",
      "Buyer's Order": "The signed purchase agreement showing vehicle details, price, and terms.",
      "Bill of Sale": "Document showing the sale transaction details between buyer and seller.",
      "Odometer Statement": "Federal disclosure statement showing the vehicle's current mileage.",
      "Power of Attorney": "If someone else is signing on your behalf, a signed POA document is required.",
      "Co-Buyer Documents": "If there's a co-buyer, their driver's license, proof of income, and proof of residence.",
      "Down Payment Receipt": "Proof of your down payment - receipt, cashier's check copy, or bank withdrawal record.",
      "Social Security Card": "A clear photo of your Social Security card for identity verification.",
      "Proof of Employment": "An employment verification letter on company letterhead, or recent pay stubs.",
      "Utility Bill": "A recent utility bill (electric, gas, water) showing your name and current address.",
      "Voided Check": "A voided check from your bank account for setting up automatic payments.",
      "Contract Signatures": "Your signed contract and financing agreement documents.",
    },
    defaultTooltip: "Please provide a clear, legible copy of this document. Accepted formats: JPG, PNG, PDF (max 20MB).",
  },

  es: {
    // Phone Entry
    docUpload: "Carga de Documentos",
    enterPhone: "Ingrese su numero de telefono para acceder a sus documentos",
    phoneNumber: "Numero de Telefono",
    phonePlaceholder: "(555) 123-4567",
    phoneError: "Por favor ingrese un numero de telefono valido de 10 digitos",
    sendCode: "Enviar Codigo de Verificacion",
    verifying: "Verificando...",
    multipleDeals: "Se encontraron multiples transacciones. Seleccione la suya:",
    needHelp: "Necesita ayuda? Comuniquese con su concesionario.",

    // PIN Verification
    verifyPhone: "Verifique su Telefono",
    enterCode: "Ingrese el codigo de 4 digitos enviado a",
    codeSent: "Codigo de verificacion enviado",
    changePhone: "Cambiar telefono",
    resendCode: "Reenviar codigo",
    resendIn: "Reenviar en",
    testPin: "PIN de prueba (SMS no configurado):",
    verificationFailed: "Verificacion fallida",

    // Document Dashboard
    docUploadTitle: "Carga de Documentos",
    lender: "Prestamista",
    docsVerified: "documentos verificados",
    of: "de",
    pendingReview: "en revision",
    custom: "Personalizado",
    uploadBtn: "Subir",
    uploading: "Subiendo...",
    waitingReview: "Esperando revision del concesionario",
    docAccepted: "Documento aceptado",
    uploadedSuccess: "subido exitosamente!",
    fileTypeError: "Tipo de archivo no permitido. Use JPG, PNG, PDF o HEIC.",
    fileSizeError: "Archivo demasiado grande. El tamano maximo es 20MB.",
    loadError: "No se pudieron cargar los documentos",
    sessionExpires: "La sesion expira en",
    contactDealer: "Necesita ayuda? Comuniquese con su concesionario.",
    reason: "Razon",

    // Status labels
    verified: "Verificado",
    pendingReviewStatus: "En Revision",
    rejected: "Rechazado",
    missing: "Pendiente",

    // Tooltips
    tooltips: {
      "Driver's License": "Una foto clara del frente de su licencia de conducir vigente. Asegurese de que todo el texto sea legible y la foto no este borrosa.",
      "Proof of Income": "Recibos de pago recientes (ultimos 30 dias), estados de cuenta bancarios o declaraciones de impuestos que muestren sus ingresos.",
      "Proof of Residence": "Una factura de servicios, estado de cuenta bancario o correo del gobierno de los ultimos 60 dias que muestre su direccion actual.",
      "Insurance Card": "Su tarjeta de seguro de auto actual o pagina de declaracion que muestre la cobertura del vehiculo que esta financiando.",
      "Vehicle Registration": "El documento de registro actual de cualquier vehiculo en intercambio, o el registro del vehiculo que se esta comprando.",
      "Bank Statements": "Los ultimos 2-3 meses de estados de cuenta bancarios mostrando su nombre, actividad y saldo actual.",
      "Pay Stubs": "Sus recibos de pago mas recientes (ultimas 2-4 semanas) mostrando su empleador, tasa de pago e ingresos del ano.",
      "Trade-in Title": "El titulo original de su vehiculo en intercambio. Si hay un gravamen, necesitaremos la informacion del acreedor.",
      "References": "Informacion de contacto de 3-5 referencias personales o profesionales (nombre, telefono, relacion).",
      "Credit Application": "Su solicitud de credito completada y firmada. Es posible que ya la hayamos recopilado durante su visita.",
      "Buyer's Order": "El acuerdo de compra firmado que muestra los detalles del vehiculo, precio y terminos.",
      "Bill of Sale": "Documento que muestra los detalles de la transaccion de venta entre comprador y vendedor.",
      "Odometer Statement": "Declaracion federal que muestra el kilometraje actual del vehiculo.",
      "Power of Attorney": "Si alguien mas firma en su nombre, se requiere un documento de poder notarial firmado.",
      "Co-Buyer Documents": "Si hay un co-comprador, su licencia de conducir, comprobante de ingresos y comprobante de domicilio.",
      "Down Payment Receipt": "Comprobante de su pago inicial: recibo, copia de cheque de caja o registro de retiro bancario.",
      "Social Security Card": "Una foto clara de su tarjeta de Seguro Social para verificacion de identidad.",
      "Proof of Employment": "Una carta de verificacion de empleo en papel membretado de la empresa, o recibos de pago recientes.",
      "Utility Bill": "Una factura de servicios reciente (electricidad, gas, agua) que muestre su nombre y direccion actual.",
      "Voided Check": "Un cheque anulado de su cuenta bancaria para configurar pagos automaticos.",
      "Contract Signatures": "Sus documentos de contrato y acuerdo de financiamiento firmados.",
    },
    defaultTooltip: "Proporcione una copia clara y legible de este documento. Formatos aceptados: JPG, PNG, PDF (max 20MB).",
  },
};

export default translations;
